import { useQuery } from '@tanstack/react-query';

import { APIClientBase } from ':cloud/state/Api';

import { QueryKey } from '../types';

type GetTokenValidationResponse = {
  hasCode?: boolean;
  isErc20?: boolean;
  decimalsValid?: boolean;
};

async function getTokenValidation({
  tokenAddress,
  network,
}: UseValidateTokenProps): Promise<GetTokenValidationResponse> {
  const path = `/chain-manager/v1/validate-token?network=${network}&address=${tokenAddress}`;
  const { data } = await APIClientBase.get<GetTokenValidationResponse>(path);
  return data;
}

type UseValidateTokenProps = {
  tokenAddress: string;
  network: string;
  isEnabled?: boolean;
};

export function useValidateToken({ tokenAddress, network, isEnabled }: UseValidateTokenProps) {
  const { isLoading, data } = useQuery({
    queryKey: [QueryKey.validateToken, tokenAddress, network],
    queryFn: async () => getTokenValidation({ tokenAddress, network }),
    enabled: isEnabled,
  });

  return {
    isLoading,
    validations: data,
  };
}
